import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-switch",
  templateUrl: "./switch.component.html",
  styleUrls: ["./switch.component.scss"],
})
export class SwitchComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
